import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-travels',
  templateUrl: './home-travels.component.html',
  styleUrls: ['./home-travels.component.scss']
})
export class HomeTravelsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/home-travels/home-travels.component.ts